export interface PuzzleModel {
    readonly puzzleType: PuzzleType;
    readonly puzzleFrame: number;
}

export enum PuzzleType {
    Type1 = "type1",
    Type2 = "type2",
    Type3 = "type3",
    Type4 = "type4",
    Type5 = "type5",
    Type6 = "type6",
    Type7 = "type7",
    Type8 = "type8",
}

export const PuzzleTypes = [
    PuzzleType.Type1,
    PuzzleType.Type2,
    PuzzleType.Type3,
    PuzzleType.Type4,
    PuzzleType.Type5,
    PuzzleType.Type6,
    PuzzleType.Type7,
    PuzzleType.Type8,
];